import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth, RequirePermission } from '@/features/auth';
import { AppLayout } from '@/app/ui/AppLayout';
import { LoginPage } from '@/pages/login';
import { InvitePage } from '@/pages/invite';
import { ProfilePage } from '@/pages/profile';
import { PlaygroundPage } from '@/pages/playground';
import { KnowledgePage } from '@/pages/knowledge';
import { RemarksPage } from '@/pages/remarks';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/playground" replace />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="playground" element={<PlaygroundPage />} />
          <Route path="playground/:dialogId" element={<PlaygroundPage />} />
          <Route path="remarks" element={<RemarksPage />} />
          <Route
            path="knowledge"
            element={
              <RequirePermission permission="can_edit_knowledge_base">
                <KnowledgePage />
              </RequirePermission>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/playground" replace />} />
    </Routes>
  );
}
